import React, { FunctionComponent } from 'react';
import { Box } from '@material-ui/core';
import { GetCustomizeCar_customizeCar_prices_carPrice_offers_discounts as IDiscount } from '../../../../../../../graphql/queries/__generated__/GetCustomizeCar';
import DiscountRow from './DiscountRow';
import summaryStyles from '../../../../summary/summarySection/SummaryStyles';

interface IDiscountsProps {
  loading: boolean;
  discounts: IDiscount[];
}

const Discounts: FunctionComponent<IDiscountsProps> = ({ loading, discounts }) => {
  const styles = summaryStyles();

  return (
    <Box className={styles.selectionContainer} data-test="summary_expanded:discounts">
      {discounts?.map(discount => (
        <DiscountRow key={discount.code} loading={loading} discount={discount} />
      ))}
    </Box>
  );
};
export default Discounts;
